export default "__VITE_ASSET__h5FPdx1_w9jyJzDlc_DUPw__"